import React, { useMemo } from 'react';
import {
  Box,
  Typography,
  Grid,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Link,
  Stack,
} from '@mui/material';
import styled from '@emotion/styled';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Mail';
import moment from 'moment';

const FormTopStyled = styled(Box)(({}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}));

const FormImageLeftStyled = styled(Box)(({}) => ({
  background: 'gray',
  width: 100,
  height: 100,
  borderRadius: 100,
  overflow: 'hidden',
  marginRight: 20,
}));

const FromTestRightStyled = styled(Box)(({}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
}));

const FormContactRowStyled = styled(Box)(({}) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '20px',
}));

function ContactUsReadOnly({ data }: any) {
  const time = useMemo(() => {
    const mmt = moment(data.createdByTime);
    return { time: mmt.format('DD MMM YYYY'), timeAgo: mmt.fromNow() };
  }, [data]);
  return (
    <Stack spacing={2} key={data._id}>
      <Typography>{time.time}</Typography>
      <Typography>{time.timeAgo}</Typography>
      <Typography>
        <b>Name</b> {data.name}
      </Typography>
      <Typography>
        <b>Email</b> {data.email}
      </Typography>
      <Typography>
        <b>Message</b>
      </Typography>
      <Typography>{data.message}</Typography>
    </Stack>
  );
}

export { ContactUsReadOnly };
